import { Heading } from '@vs-shop/ui/heading';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

import Breadcrumbs from '../../navigation/Breadcrumbs';

export default function ProductsComparisonHeader() {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <>
      <div className="py-2 tab:py-3 lap:py-4">
        <Breadcrumbs
          breadcrumbs={[]}
          currentName={intl.formatMessage({
            id: 'productsComparison.breadcrumbs.productsComparison',
            defaultMessage: 'Porovnání produktů',
          })}
        />
      </div>

      <Heading level={1}>
        {intl.formatMessage({
          id: 'productsComparison.heading',
          defaultMessage: 'Porovnání produktů',
        })}
      </Heading>
    </>
  );
}
